import { render } from "./TextBox.vue?vue&type=template&id=0d805c67&ts=true"
import script from "./TextBox.vue?vue&type=script&lang=ts"
export * from "./TextBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__